import { EaseFunction } from "./EaseFunction";
import { gsap } from "gsap/dist/gsap";

export abstract class CustomEase {
    public static parse(data: string | EaseFunction): EaseFunction {
        //data = "M0,0,C0,0,0.05,0.228,0.09,0.373,0.12,0.484,0.139,0.547,0.18,0.654,0.211,0.737,0.235,0.785,0.275,0.864,0.291,0.896,0.303,0.915,0.325,0.944,0.344,0.97,0.356,0.989,0.38,1.009,0.413,1.039,0.441,1.058,0.48,1.08,0.496,1.089,0.51,1.091,0.53,1.095,0.552,1.099,0.567,1.101,0.59,1.099,0.623,1.097,0.646,1.094,0.68,1.085,0.768,1.061,0.822,1.035,0.91,1.011,0.943,1.002,1,1,1,1";
        let easeFunction = gsap.parseEase(data);
        return <EaseFunction>easeFunction;
    }

    public static register(easeName: string, data: string | EaseFunction): void {
        let easeFunction = gsap.parseEase(data);
        gsap.registerEase(easeName, easeFunction);
    }
}